import _toConsumableArray from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import pagination from '@/views/mixin/page'
import customContainerHeader from '@/components/custom-container-header';
import { page, rolelist, putObj, Status, Delete, IsExistsName, ResetPassword, ExportListData, PurchaseImportData, GetImportTplUrlForPurchase } from '@/api/sys.user';
import util from '@/libs/util.js';
import { LoadData as _LoadData, LoadUserOrganize } from '@/api/SysOrganize';
import store from '@/store/index';
import ExportListMixin from '@/views/mixin/ExportList';
export default {
  name: 'Manager',
  mixins: [ExportListMixin],
  components: {
    customContainerHeader: customContainerHeader
  },
  data: function data() {
    return {
      mainTable: [],
      loading: false,
      titleText: '',
      drawer: false,
      form: {
        USER_NAME: null,
        ROLE_ID: null,
        NICK_NAME: null,
        ENABLED: true,
        ORGANIZE_IDS: [],
        ORGANIZE_ID_STRING: [],
        MOBILE: null,
        REMARK: null
      },
      formData: {
        Page: 1,
        Limit: 15,
        Key: null
      },
      roleList: [],
      // 验证
      rules: {
        USER_NAME: [{
          required: true,
          message: this.$t('Manager.PleaseAccount'),
          trigger: ['blur', 'change']
        }],
        NICK_NAME: [{
          required: true,
          message: this.$t('Manager.pleaseUserNic'),
          trigger: ['blur', 'change']
        }],
        ROLE_ID: [{
          required: true,
          message: this.$t('Manager.pleaseRoles'),
          trigger: ['blur', 'change']
        }],
        ORGANIZE_ID_STRING: [{
          required: true,
          message: this.$t('Manager._3'),
          trigger: ['blur', 'change']
        }]
      },
      parentTreeList: [],
      casProps: {
        label: 'ORGANIZE_NAME',
        value: 'ID',
        children: 'children',
        checkStrictly: true,
        multiple: true,
        emitPath: true
      },
      planData: [],
      isFhow: true,
      UploadParamVal: {
        organize_id: util.cookies.get('ORG_ID')
      },
      uploadUrlEx: util.cookies.get('userApi') + 'Manager/PurchaseImportData',
      totalPage: 0
    };
  },
  methods: {
    handleSizeChange: function handleSizeChange(size) {
      this.formData.Limit = size;
      this.getLoadData();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      console.log(page);
      this.formData.Page = page;
      this.getLoadData();
    },
    dialogClose: function dialogClose() {
      this.cancel();
    },
    changeUSER_NAME: function changeUSER_NAME(e) {// this.$forceUpdate()
    },
    changeROLE_ID: function changeROLE_ID(e) {// this.$forceUpdate()
    },
    changeNICK_NAME: function changeNICK_NAME(e) {// this.$forceUpdate()
    },
    changeMOBILE: function changeMOBILE(e) {// this.$forceUpdate()
    },
    changeWORK_WECHAT_ID: function changeWORK_WECHAT_ID(e) {// this.$forceUpdate()
    },
    changeENABLED: function changeENABLED(e) {// this.$forceUpdate()
    },
    changeREMARK: function changeREMARK(e) {// this.$forceUpdate()
    },
    getIndex: function getIndex() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.getLoadData();

                _this.getRole();

                _this.getTreeData();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleChangeCascader: function handleChangeCascader(e) {
      var _this2 = this;

      this.form.ORGANIZE_ID_STRING = [];

      if (e && e.length) {
        e.map(function (item) {
          if (item && item.length) {
            _this2.form.ORGANIZE_ID_STRING.push(item[item.length - 1]);
          }
        });
      }

      this.form.ORGANIZE_ID_STRING = this.form.ORGANIZE_ID_STRING.join(',');
      console.log('this.form.ORGANIZE_ID_STRING', this.form.ORGANIZE_ID_STRING);
      this.$forceUpdate();
    },
    getTreeData: function getTreeData() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _LoadData({
                  Page: 1,
                  Limit: 100000000
                });

              case 2:
                res = _context2.sent;
                _this3.planData = res.data || [];
                _this3.parentTreeList = res.data ? _this3.getTree(res.data) : [];

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 递归
    getTree: function getTree(data) {
      var _this4 = this;

      var pid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var arr = [];
      data.map(function (item) {
        if (item.PARENT_ORGANIZE_ID === pid) {
          item.level = level;
          item.children = _this4.getTree(data, item.ID, level + 1);
          item.disabled = item.ENABLED === 'N';
          arr.push(item);
        }
      });
      return arr;
    },
    exportData: function exportData() {
      // this.loading = true
      ExportListData({
        TYPE_ID: '1',
        ORGANIZE_ID: util.cookies.get('ORG_ID')
      });
      this.$message.success('已添加到 导出列表 中');
      this.setUnreadExportMessionNum(); // if (res.code === 0) {
      //   window.open(`${process.env.VUE_APP_FILE_PATH}${res.data}`)
      // } else {
      //   this.$message.error(res.message)
      // }
      // this.loading = false
      // this.mainTable = res.Result || []
      // this.totalPage = res.TotalCount || 0
    },
    // 获取用户列表
    getLoadData: function getLoadData() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params, response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this5.loading = true;
                params = {
                  Page: _this5.formData.Page,
                  Limit: _this5.formData.Limit,
                  Key: _this5.formData.Key,
                  LIST_ROUTE: store.getters.routerPath,
                  TYPE_ID: '1',
                  ORGANIZE_ID: util.cookies.get('ORG_ID')
                };
                _context3.next = 4;
                return page(params);

              case 4:
                response = _context3.sent;
                // console.log('用户列表',response);
                _this5.loading = false;
                _this5.mainTable = response.data.Items || [];
                _this5.totalPage = response.data.TotalCount || []; // console.log(this.mainTable, '获取用户')

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    handleFilter: function handleFilter() {
      this.formData.Page = 1;
      this.getLoadData();
    },
    handleCreate: function handleCreate() {
      var _this6 = this;

      delete this.form.ID;
      this.form.ROLE_ID = null;
      this.form.USER_NAME = null;
      this.form.NICK_NAME = null;
      this.form.MOBILE = null;
      this.form.WORK_WECHAT_ID = null;
      this.form.ENABLED = true;
      this.form.REMARK = null;
      this.form.ORGANIZE_IDS = [];
      this.form.ORGANIZE_ID_STRING = [];
      this.form.Email = null;
      this.drawer = true;
      this.titleText = '新增采购员账号';
      this.$nextTick(function () {
        _this6.$refs.xuser.clearValidate();
      });
    },
    // 获取角色列表
    getRole: function getRole() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return rolelist();

              case 2:
                response = _context4.sent;

                if (response.code === 0) {
                  _this7.roleList = response.data || [];
                } else {
                  _this7.roleList = [];
                }

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    change: function change(_ref) {
      var _this8 = this;

      var $index = _ref.$index,
          row = _ref.row;
      this.$confirm(this.$t('Manager.Modifystatus'), this.$t('Manager.prompt'), {
        confirmButtonText: this.$t('Manager.confirm'),
        cancelButtonText: this.$t('Manager.cancel'),
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return Status({
                  Id: row.Id,
                  Status: row.IsENABLED
                });

              case 2:
                res = _context5.sent;

                if (res.code === 0) {
                  _this8.getLoadData();

                  _this8.$message({
                    type: 'success',
                    message: _this8.$t('Manager.Succfied')
                  });
                } else {
                  _this8.getLoadData();
                }

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))).catch(function () {
        _this8.getLoadData();

        _this8.$message({
          type: 'info',
          message: _this8.$t('Manager.edit')
        });
      });
    },
    handleEdit: function handleEdit(_ref3) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var row;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                row = _ref3.row;
                // this.$set(this.form, 'ID', row.Id)
                // this.$set(this.form, 'ROLE_ID', row.Role_Id)
                // this.$set(this.form, 'USER_NAME', row.User_Name)
                // this.$set(this.form, 'NICK_NAME', row.Nick_Name)
                // this.$set(this.form, 'MOBILE', row.Mobile || '')
                // this.$set(this.form, 'WORK_WECHAT_ID', row.Work_Wechat_Id || '')
                // this.$set(this.form, 'ENABLED', row.IsENABLED)
                // this.$set(this.form, 'REMARK', row.Remark || '')
                // this.$set(this.form, 'ORGANIZE_IDS', [])
                // this.$set(this.form, 'Email', row.Email || '')
                console.log('row', row);
                _this9.form.ID = row.Id;
                _this9.form.ROLE_ID = row.Role_Id;
                _this9.form.USER_NAME = row.User_Name;
                _this9.form.NICK_NAME = row.Nick_Name;
                _this9.form.MOBILE = row.Mobile || '';
                _this9.form.WORK_WECHAT_ID = row.Work_Wechat_Id || '';
                _this9.form.ENABLED = row.IsENABLED;
                _this9.form.REMARK = row.Remark || '';
                _this9.form.ORGANIZE_IDS = [];
                _this9.form.ORGANIZE_ID_STRING = [];
                _this9.form.Email = row.Email || '';

                _this9.getPeopleList(row.Id); // this.$set(
                //   this.form,
                //   'ORGANIZE_ID_STRING',
                //   this.form.ORGANIZE_IDS.join(',')
                // )
                // console.log('this.form.ORGANIZE_ID_STRING', this.form.ORGANIZE_ID_STRING)


                _this9.drawer = true;
                _this9.titleText = '修改采购员账号';

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    onSubmit: function onSubmit() {
      var _this10 = this;

      this.form.TYPE_ID = '1';
      this.form.ORGANIZE_ID = util.cookies.get('ORG_ID');
      this.$refs.xuser.validate( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(valid, errInfo) {
          var response, result;
          return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  if (!valid) {
                    _context7.next = 14;
                    break;
                  }

                  _context7.next = 3;
                  return IsExistsName(_this10.form);

                case 3:
                  response = _context7.sent;

                  if (!(response.data !== void 0)) {
                    _context7.next = 12;
                    break;
                  }

                  if (!response.data) {
                    _context7.next = 8;
                    break;
                  }

                  _this10.$message.error(_this10.$t('Manager.userExcite'));

                  return _context7.abrupt("return", false);

                case 8:
                  _context7.next = 10;
                  return putObj(_this10.form);

                case 10:
                  result = _context7.sent;

                  if (result.code === 0) {
                    _this10.cancel();

                    _this10.getLoadData();

                    _this10.$notify({
                      title: _this10.$t('Manager.success'),
                      message: _this10.$t('publics.tips.handleSuccess'),
                      type: 'success',
                      duration: 2000
                    });
                  }

                case 12:
                  _context7.next = 15;
                  break;

                case 14:
                  try {
                    Object.keys(errInfo).forEach(function (item) {
                      _this10.$message.error(errInfo[item][0].message);

                      throw Error(errInfo[item][0].message);
                    });
                  } catch (e) {
                    console.log(e.message);
                  }

                case 15:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }));

        return function (_x, _x2) {
          return _ref4.apply(this, arguments);
        };
      }());
    },
    cancel: function cancel() {
      var _this11 = this;

      // this.form = {}
      // this.form.ENABLED = true
      // this.form.ID = null
      // this.form.ROLE_ID = null
      // this.form.USER_NAME = null
      // this.form.NICK_NAME = null
      // this.form.MOBILE = null
      // this.form.WORK_WECHAT_ID = null
      // this.form.ENABLED = true
      // this.form.REMARK = null
      // this.form.ORGANIZE_IDS = []
      // this.form.ORGANIZE_ID_STRING = []
      // this.form.Email = null
      setTimeout(function () {
        _this11.$refs.xuser.clearValidate();

        _this11.drawer = false;
      }, 100);
    },
    handleDelete: function handleDelete(_ref5) {
      var _this12 = this;

      var row = _ref5.row;
      this.$confirm(this.$t('Manager.deleteUser'), this.$t('Manager.prompt'), {
        confirmButtonText: this.$t('Manager.confirm'),
        cancelButtonText: this.$t('Manager.cancel'),
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var _response;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return Delete(row.Id);

              case 2:
                _response = _context8.sent;

                if (_response.code === 0) {
                  _this12.$notify({
                    title: _this12.$t('Manager.success'),
                    message: _this12.$t('Manager.succDeleted'),
                    type: 'success',
                    duration: 2000
                  });

                  _this12.getLoadData();
                }

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      })));
    },
    getPeopleList: function getPeopleList(MANAGER_ID) {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var res, data;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return LoadUserOrganize({
                  MANAGER_ID: MANAGER_ID,
                  Page: 1,
                  Limit: 100000
                });

              case 2:
                res = _context9.sent;
                data = res.data || []; // console.log('组织 res',data);
                // console.log('this.planData',this.planData);

                _this13.form.ORGANIZE_IDS = [];
                data.map(function (item) {
                  // if (item.STATUS === 'Y') {
                  //   this.form.ORGANIZE_IDS.push(item.ORGANIZE_ID)
                  // }
                  _this13.form.ORGANIZE_IDS.push(item.ORGANIZE_ID);
                });
                _this13.form.ORGANIZE_IDS = _toConsumableArray(new Set(_this13.form.ORGANIZE_IDS));
                _this13.form.ORGANIZE_IDS = _this13.form.ORGANIZE_IDS.map(function (item) {
                  return _this13.reverseGetTree(_this13.planData, item);
                });
                _this13.form.ORGANIZE_ID_STRING = _this13.form.ORGANIZE_IDS.join(',');
                _this13.isFhow = false;

                _this13.$nextTick(function () {
                  _this13.isFhow = true;
                });

              case 11:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    // 递归
    reverseGetTree: function reverseGetTree(data, id) {
      var _this14 = this;

      var arr = [];
      data.map(function (item) {
        if (item.ID === id) {
          if (item.PARENT_ORGANIZE_ID) {
            arr.push.apply(arr, _toConsumableArray(_this14.reverseGetTree(data, item.PARENT_ORGANIZE_ID)));
          }

          arr.push(item.ID);
        }
      });
      return arr;
    },
    // 重置密码
    resetPwd: function resetPwd() {
      var _this15 = this;

      this.$confirm(this.$t('Manager._5'), this.$t('Manager._6'), {
        confirmButtonText: this.$t('Manager.confirm'),
        cancelButtonText: this.$t('Manager.cancel'),
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var res;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return ResetPassword(_this15.form);

              case 2:
                res = _context10.sent;

                if (res.code === 0) {
                  _this15.$notify({
                    title: _this15.$t('Manager.success'),
                    message: _this15.$t('Manager._7'),
                    type: 'success'
                  });
                }

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      })));
    },
    // 上传文件前
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      // debugger
      var isExcelFile = file.name.endsWith('.xlsx');
      var isLt2M = file.size / 1024 / 1024 < 10;

      if (!isExcelFile) {
        this.$message.error(this.$t('publics.file_ext_err'));
        return false;
      }

      if (!isLt2M) {
        this.$message.error(this.$t('publics.file_szie_err'));
        return false;
      }

      this.NaturaLloading = this.$loading({
        lock: true,
        // 同v-loading的修饰符
        text: this.$t('正在上传中...'),
        // 加载文案
        backgroundColor: 'rgba(55,55,55,0.4)',
        // 背景色
        spinner: 'el-icon-loading' // 加载图标

      });
      return isExcelFile && isLt2M;
    },
    // 上传成功后
    handleAvatarSuccess: function handleAvatarSuccess(response) {
      if (response.ErrorInfo.Status === true || response.Result === false) {
        this.$message({
          dangerouslyUseHTMLString: true,
          duration: 0,
          showClose: true,
          message: response.ErrorInfo.Message || '上传失败',
          type: 'error'
        });
      } else {
        this.getIndex();
        this.$message({
          type: 'success',
          message: this.$t('se.picsucc')
        });
      }

      this.NaturaLloading.close();
    },
    handleClose: function handleClose() {
      this.$refs.uploadProcess.clearFiles();
    },
    downExcelTpl: function downExcelTpl() {
      var _this16 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var res;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return GetImportTplUrlForPurchase();

              case 2:
                res = _context11.sent;

                if (res.code === 0) {
                  // util.open(`${process.env.VUE_APP_FILE_PATH}/${res.data}`)
                  util.open("".concat(_this16.$store.getters.getVUE_APP_FILE_PATH, "/").concat(res.data)); // console.log(`${this.$store.getters.getVUE_APP_FILE_PATH}/${res.data}`)
                } else {
                  _this16.$message.error(res.message);
                }

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }))();
    }
  },
  created: function created() {
    // console.log(this.$btnList.indexOf('ManagerAdd'))
    this.getIndex();
  } // watch: {
  //   form: {
  //     handler () {
  //       this.$forceUpdate()
  //     },
  //     deep: true
  //   }
  // }

};